import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-what-we-do6',
  templateUrl: './section-what-we-do6.component.html',
  styleUrls: ['./section-what-we-do6.component.css']
})
export class SectionWhatWeDo6Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
